/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {PresetGrantsRequest} from '../models/PresetGrantsRequest';
import type {PresetGrantsResponse} from '../models/PresetGrantsResponse';

export interface AssignGrants$Request {
    presetGrantsRequest: PresetGrantsRequest;
}

export interface AssignGrants$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignGrantsRequest = createAction<PayloadData<void, AssignGrants$Request>>('BULK_ASSIGN_PRESET_GRANTS__ASSIGN_GRANTS__REQUEST');
export const assignGrantsSuccess = createAction<PayloadData<string, AssignGrants$Request>>('BULK_ASSIGN_PRESET_GRANTS__ASSIGN_GRANTS__SUCCESS');
export const assignGrantsFailure = createAction<PayloadData<Error, AssignGrants$Request, true>>('BULK_ASSIGN_PRESET_GRANTS__ASSIGN_GRANTS__FAILURE');

export const assignGrantsActions = [
    assignGrantsRequest,
    assignGrantsSuccess,
    assignGrantsFailure
] as const;

/**
 * @param {PresetGrantsRequest} meta.presetGrantsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignGrants = (meta: AssignGrants$Request, config?: AssignGrants$Config) => {
    return {
        CALL_API: {
            types: assignGrantsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/presets/assign-grants`,
            TRANSPORT_REQUEST_BODY: meta.presetGrantsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface BulkAssignPresetGrantsProgress$Request {
    id: string;
}

export interface BulkAssignPresetGrantsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkAssignPresetGrantsProgressRequest = createAction<PayloadData<void, BulkAssignPresetGrantsProgress$Request>>('BULK_ASSIGN_PRESET_GRANTS__BULK_ASSIGN_PRESET_GRANTS_PROGRESS__REQUEST');
export const bulkAssignPresetGrantsProgressSuccess = createAction<PayloadData<BulkProgress, BulkAssignPresetGrantsProgress$Request>>('BULK_ASSIGN_PRESET_GRANTS__BULK_ASSIGN_PRESET_GRANTS_PROGRESS__SUCCESS');
export const bulkAssignPresetGrantsProgressFailure = createAction<PayloadData<Error, BulkAssignPresetGrantsProgress$Request, true>>('BULK_ASSIGN_PRESET_GRANTS__BULK_ASSIGN_PRESET_GRANTS_PROGRESS__FAILURE');

export const bulkAssignPresetGrantsProgressActions = [
    bulkAssignPresetGrantsProgressRequest,
    bulkAssignPresetGrantsProgressSuccess,
    bulkAssignPresetGrantsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkAssignPresetGrantsProgress = (meta: BulkAssignPresetGrantsProgress$Request, config?: BulkAssignPresetGrantsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: bulkAssignPresetGrantsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/assign-grants/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetAssignGrantsResult$Request {
    id: string;
}

export interface GetAssignGrantsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAssignGrantsResultRequest = createAction<PayloadData<void, GetAssignGrantsResult$Request>>('BULK_ASSIGN_PRESET_GRANTS__GET_ASSIGN_GRANTS_RESULT__REQUEST');
export const getAssignGrantsResultSuccess = createAction<PayloadData<PresetGrantsResponse, GetAssignGrantsResult$Request>>('BULK_ASSIGN_PRESET_GRANTS__GET_ASSIGN_GRANTS_RESULT__SUCCESS');
export const getAssignGrantsResultFailure = createAction<PayloadData<Error, GetAssignGrantsResult$Request, true>>('BULK_ASSIGN_PRESET_GRANTS__GET_ASSIGN_GRANTS_RESULT__FAILURE');

export const getAssignGrantsResultActions = [
    getAssignGrantsResultRequest,
    getAssignGrantsResultSuccess,
    getAssignGrantsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAssignGrantsResult = (meta: GetAssignGrantsResult$Request, config?: GetAssignGrantsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getAssignGrantsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/presets/assign-grants`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

